export default "__VITE_ASSET__Cv_7mCVR__"